import React, { useContext } from 'react';
import axios from 'axios'
import { LiaCommentSolid } from "react-icons/lia";
import { LuCalendarClock, LuCircleFadingPlus } from "react-icons/lu";
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import { RiInfoCardLine } from "react-icons/ri";
import {
    MdOutlineMoneyOffCsred,
    MdOutlineRemoveShoppingCart,
    MdRestore
} from "react-icons/md";
import { PiGavel } from 'react-icons/pi';
import { RiDeleteBin2Line } from "react-icons/ri";
import { apiRoute, ThemeModeContext } from '../../../../App';

const ViolationActions = (props) => {
    const {
        anchorEl,
        params,
        handleCloseDropdown,
        handleOpen,
        disbursedFees,
        addFeesCheck,
        setViolationData,
        state,
        addSuspendedCheck,
        feeFineRows,
        paymentPlanModal,
        setPaymentPlanModal,
        planCreated,
    } = props;

    const { mode } = useContext(ThemeModeContext);

    function handlePaymentPlanModal() {
        setPaymentPlanModal(!paymentPlanModal);
    };

    return (
        <Menu
            id='violation-menu'
            anchorEl={anchorEl[params.row.id]}
            open={Boolean(anchorEl[params.row.id])}
            onClose={() => handleCloseDropdown(params.row.id)}
            MenuListProps={{
                'aria-labelledby': 'violation-actions',
            }}
        >
            {/*<MenuItem>*/}
            {/*    <Tooltip*/}
            {/*        title={<h6>Payment Plan Already Created For This Violation</h6>}*/}
            {/*        disableHoverListener={!planCreated | !params.row.disableDelete}*/}
            {/*        placement="left"*/}
            {/*    >*/}
            {/*        <span style={{ width: '100%' }}>*/}
            {/*            <Button*/}
            {/*                fullWidth*/}
            {/*                sx={{ backgroundColor: mode === 'dark' ? '#50C878' : '#52c176', color: 'white' }}*/}
            {/*                variant="contained"*/}
            {/*                onClick={() => {*/}
            {/*                    handlePaymentPlanModal();*/}
            {/*                    handleCloseDropdown(params.row.id);*/}
            {/*                }}*/}
            {/*                disabled={planCreated | !state.isActive | state.isDeleted}*/}
            {/*                startIcon={<LuCalendarClock />}*/}
            {/*            >*/}
            {/*                Create Payment Plan*/}
            {/*            </Button>*/}
            {/*        </span>*/}
            {/*    </Tooltip>*/}
            {/*</MenuItem>*/}
            <MenuItem>
                <Button
                    fullWidth
                    onClick={() => {
                        handleOpen('addFeesByType', '50%');
                        handleCloseDropdown(params.row.id);
                    }}
                    variant="contained"
                    disabled={params.row.currentStatute === 'DISMISSED' | !state.isActive | state.isDeleted}
                    sx={{ backgroundColor: "steelblue", color: 'white' }}
                    startIcon={<LuCircleFadingPlus />}
                >
                    Add Fees To Violation
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    onClick={async () => {
                        handleOpen('sentencing', '75%');
                        handleCloseDropdown(params.row.id);
                        axios.get(`${apiRoute}/api/ViolationTbls/${params.row.pkViolationId}`)
                            .then(res => {
                                setViolationData(res.data);
                                handleOpen('sentencing', '75%')
                            })
                            .catch(err => console.log(err))
                    }
                    }
                    variant="contained"
                    sx={{ backgroundColor: "steelblue", color: 'white' }}
                    startIcon={<PiGavel />}
                >
                    Sentencing Details
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    onClick={() => {
                        handleOpen('violationInfo', '75%', true);
                        handleCloseDropdown(params.row.id);
                    }}
                    variant="contained"
                    sx={{ backgroundColor: "steelblue", color: 'white' }}
                    startIcon={<RiInfoCardLine />}
                > Violation Info
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    onClick={() => {
                        handleOpen('Comments', '40%');
                        handleCloseDropdown(params.row.id);
                    }}
                    variant="contained"
                    sx={{ backgroundColor: "steelblue", color: 'white' }}
                    startIcon={<LiaCommentSolid />}
                >
                    Comments
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    sx={{ backgroundColor: 'gold', color: 'black' }}
                    variant="contained"
                    onClick={() => {
                        handleOpen('suspendAll', '45%');
                        handleCloseDropdown(params.row.id);
                    }}
                    disabled={!feeFineRows.length | addSuspendedCheck() ? true : !addFeesCheck() ? true : !state.isActive ? true : state.isDeleted ? true : disbursedFees}
                    startIcon={<MdOutlineMoneyOffCsred />}
                >
                    <strong>
                        Suspend All
                    </strong>
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    sx={{ backgroundColor: 'gold', color: 'black' }}
                    variant="contained"
                    onClick={(e) => {
                        handleOpen('deleteFees', '45%');
                        handleCloseDropdown(params.row.id);
                    }}
                    disabled={!feeFineRows.length | !addFeesCheck() | addSuspendedCheck() | !state.isActive | state.isDeleted}
                    startIcon={<MdOutlineRemoveShoppingCart />}
                >
                    <strong>
                        Clear All
                    </strong>
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    sx={{ backgroundColor: '#50C878', color: 'black' }}
                    variant="contained"
                    onClick={() => {
                        handleOpen('revertSuspended', '45%');
                        handleCloseDropdown(params.row.id);
                    }}
                    disabled={!feeFineRows.length | (addSuspendedCheck() ? false : addFeesCheck() ? true : !state.isActive ? true : state.isDeleted ? true : disbursedFees)}
                    startIcon={<MdRestore />}
                >
                    <strong>
                        Revert Suspended
                    </strong>
                </Button>
            </MenuItem>
            <MenuItem>
                <Button
                    fullWidth
                    sx={{ backgroundColor: '#50C878', color: 'black' }}
                    variant="contained"
                    onClick={() => {
                        handleOpen('revertCleared', '45%');
                        handleCloseDropdown(params.row.id);
                    }}
                    disabled={!feeFineRows.length | addSuspendedCheck() ? true : addFeesCheck() ? true : !state.isActive ? true : state.isDeleted ? true : disbursedFees}
                    startIcon={<MdRestore />}
                >
                    <strong>
                        Revert Cleared
                    </strong>
                </Button>
            </MenuItem>
            <MenuItem>
                <Tooltip
                    title={<h6>Can't delete a violation that has a payment or cash bond applied to it</h6>}
                    disableHoverListener={!params.row.disableDelete}
                    placement="left"
                >
                    <span style={{ width: '100%' }}>
                        <Button
                            fullWidth
                            onClick={(e) => {
                                handleOpen('delete', '40%');
                                handleCloseDropdown(params.row.id);
                            }}
                            variant="contained"
                            sx={{ backgroundColor: "#ae0e0e", color: 'white' }}
                            disabled={params.row.disableDelete | !state.isActive | state.isDeleted}
                            startIcon={<RiDeleteBin2Line />}
                        >
                            Delete Violation
                        </Button>
                    </span>
                </Tooltip>
            </MenuItem>
        </Menu >
    )
}

export default ViolationActions;